import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators';
import { Events } from '../../events/app-events';
import { DepInjMixin, requires } from '../../mixins/dependency';
import { UserService } from '../../services/user-service';
import { commonPopupStyle } from '../../styles/common-style';
import { eventBus } from '../../utils/event-bus';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';


type Deps = {
  userService: UserService;
};

@requires(UserService.serviceName)
@customElement('experiance-popup')
export class ExperiancePopup extends DepInjMixin<Deps>(DeviceAwareComponent) {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        #art {
          width: 90%;
          height: 30rem;
        background-image: url(./assets/impressed-popup.svg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .title{
        font-size: 3rem;
        font-weight: var(--font-weight-emphasize);
        color: var(--c-text);
      }
      .message{
        font-weight: var(--font-weight-emphasize);
        padding-inline: 3rem;
        color: var(--c-text-sec);
      }
      @media screen and  (max-width: 370px) {
        #art {
          height: 25rem;
        }
      }
    `,
    ];
  };

  private unsubs: Function[] = [];

  @state()
    username: string = '';

  connectedCallback() {
    super.connectedCallback();
    this.unsubs.push(
      eventBus().on<void>(
        Events.Type.Refresh,
        this.checkLoginState.bind(this),
      ),
    );
    this.checkLoginState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubs.forEach((f) => f());
  }


  private checkLoginState() {
    this.username = this.deps.userService.getNameTitle();
  }



  render() {
    return html`
      <h1 class="title">${t('T_Experiance_Title', this.username)}</h1>
      <div id="art"></div>
      <p class="message">${t('T_Experiance_Text')}</p>
    `;
  }
}
